import { ThemeSkin, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
export function getBackgroundVariant(theme = ThemeOptions.DARK, themeSkin) {
    if (themeSkin === ThemeSkin.GREEN && theme === ThemeOptions.LIGHT) {
        return 'green';
    }
    return theme;
}

//# sourceMappingURL=helpers.js.map